import {
  SET_LOADING,
  SET_ERROR,
  CLEAR_ERROR,
  SET_SUCCESS,
  CLEAR_SUCCESS,
} from '../types';

const initialState = {
  loading: false,
  error: null,
  success: null,
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    case SET_SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: false,
      };

    case CLEAR_SUCCESS:
      return {
        ...state,
        success: null,
      };

    default:
      return state;
  }
};

export default uiReducer;
